module.exports = __webpack_public_path__ + "static/media/Resume-v1.9.04137ded.pdf";